import "./index.scss"
const ThirdPlatform = () => {
    return (
        <div className="index">
            <iframe
                title="YouTube Video"
                width="100%"
                height="100%"
                src="https://502143.aquas.com.tw/main.php"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            ></iframe>
        </div>
    );
};
export default ThirdPlatform;
